<div *ngIf="ticket">
  <div class="stick-top">
    <mat-toolbar style="padding: 10px;">
      <mat-icon>emergency</mat-icon>
      {{ !ticket.id ? 'Create new Trouble Ticket' : ('Trouble Ticket ' + formatTicketNumber(ticket.ticketNumber)) }}
      <span *ngIf="ticket.id" [ngClass]="ticket.status == 0 ? 'CRITICAL' : 'CLEARED'"
            style="margin-left: 10px; padding: 0 5px;">{{ formatStatus(ticket) }}</span>
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button routerLink="/tickets" >
        <mat-icon>keyboard_backspace</mat-icon>
        Back
      </button>
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{ !ticket.id ? 'add' : 'save' }}</mat-icon>
        {{ (ticket.id ? 'Update ' : 'Add ') }}
      </button>
      <span *ngIf="ticket.id && ticket.status === 0">
                      <button mat-raised-button class="" style="background-color: green !important; color: white !important;"
                              type="button" (click)="toggleTicketStatus()" [disabled]="!form.form.valid">
                        <mat-icon>emergency</mat-icon>
                        Close Ticket
                      </button>
                    </span>
      <span *ngIf="ticket.id && ticket.status > 0">
                      <button mat-raised-button class=""
                              style="background-color: #b71c1c !important; color: white !important;" type="button"
                              (click)="toggleTicketStatus()" [disabled]="!form.form.valid">
                        <mat-icon>emergency</mat-icon>
                        Open Ticket
                      </button>
                    </span>

    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Event Information">
      <div class="padded vbox-space">
        <form #form="ngForm" role="form" class="vbox-full">
          <table class="basicTable vtable" style="width: 100% !important;">
            <tbody>
            <tr>
              <td colspan="99">
                <span>Logged by <micro-user-lookup [userId]="ticket.loggedByUserId"></micro-user-lookup></span>
                <span *ngIf="ticket.id"> on {{ ticket.startTime | dateTime }}</span>
                <span *ngIf="ticket.id && ticket.updatedDateTime">&nbsp;| Last updated by <micro-user-lookup
                  [userId]="ticket.updatedByUserId"></micro-user-lookup>
                on {{ ticket.updatedDateTime | dateTime }}</span>
              </td>
            </tr>

            <tr>
              <td colspan="99">

                <b>
                  <micro-valid-label for="faultDescription" [model]="faultDescription"
                                     label="Event Description"></micro-valid-label>
                </b><br/>
                <textarea style="min-width: 350px; min-height: 220px;"
                          #faultDescription="ngModel"
                          [(ngModel)]="ticket.faultDescription"
                          placeholder="None"
                          [required]="true"
                          rows="8"
                          id="faultDescription"
                          name="faultDescription">
                </textarea>
              </td>
            </tr>
            <tr>
              <td style="min-width: 250px; padding-bottom: 10px;">
                <b>
                  <micro-valid-label for="startTimeEpoch" [model]="startTimeEpoch"
                                     label="Start Time"></micro-valid-label>
                </b><br/>
                <micro-date-picker #startTimeEpoch="ngModel"
                                   [(ngModel)]="ticket.startTime"
                                   [(dateEpoch)]="ticket.startTimeEpoch"
                                   [allowInfinite]="false"
                                   [required]="true"
                                   id="startTimeEpoch"
                                   name="startTimeEpoch">
                </micro-date-picker>
              </td>
              <td style="min-width: 250px; padding-bottom: 10px;">
                <table class="simpleTable" style="border: none; border-collapse: collapse;">
                  <tr>
                    <td style="border: none; border-collapse: collapse;">
                      <b>End Time</b>
                      <micro-date-picker [(dateEpoch)]="ticket.endTimeEpoch"
                                         [allowInfinite]="false"></micro-date-picker>
                    </td>
                    <td style="border: none; border-collapse: collapse;">
                    </td>
                  </tr>
                </table>
              </td>
              <td style="min-width: 250px; padding-bottom: 10px;">
                <input type="checkbox" [(ngModel)]="ticket.interfailingAlarmFault" name="interfailingAlarmFault"/> <b>Interfailing Alarm/Fault</b>
              </td>
            </tr>
            <tr>
              <th class="colheader uppercase" style="width: 25%">
                <b>Affected Resource</b>
              </th>
              <th class="colheader uppercase" style="width: 25%">
                <b>Event Classification</b>
              </th>
              <th class="colheader uppercase" style="width: 25%">
                <b>Event Assignment</b>
              </th>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <table class="simpleTable">
                  <tr>
                    <td>
                      <b>Type</b>
                      <div class="hbox lightly-padded">
                        <micro-radio
                          spacing="3px"
                          [options]="[
                             {positive: 'Site', negative: 'Site', value: 'SITE'},
                             {positive: 'NE', negative: 'NE', value: 'NE'},
                             {positive: 'Link', negative: 'Link', value: 'LINK'},
                             {positive: 'Service', negative: 'Service', value: 'SERVICE'},
                             {positive: 'Customer Fault', negative: 'Customer Fault', value: 'CUSTOMER_FAULT'},
                             {positive: 'Subscriber', negative: 'Subscriber', value: 'SUBSCRIBER'}]"
                          [(value)]="ticket.affectedResourceType">
                        </micro-radio>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="ticket.affectedResourceType === 'NE' || ticket.affectedResourceType === 'SITE'">
                    <td>
                      <b>
                        <micro-valid-label for="neId" [model]="neId" label="Network Element"></micro-valid-label>
                      </b><br>
                      <table class="simpleTable" style="width: 100%;">
                        <tr>
                          <td style="width: 25%">
                            <micro-net-select #netId="ngModel" [(ngModel)]="filterNetId"
                                              [placeholder]="'Network Type'"
                                              [jump]="false"
                                              id="netId" name="netId">
                            </micro-net-select>
                          </td>
                          <td style="width: 75%">
                            <micro-ne-select #neId="ngModel"
                                             [(ngModel)]="ticket.neId"
                                             [netId]="filterNetId"
                                             [siteId]="ticket.siteId"
                                             [placeholder]="'Select Network Element'"
                                             (neChange)="neChanged($event)"
                                             [required]="ticket.affectedResourceType === 'NE'"
                                             id="neId" name="neId">
                            </micro-ne-select>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr *ngIf="ticket.affectedResourceType === 'SITE'">
                    <td>
                      <b>
                        <micro-valid-label for="labSiteSiteId" [model]="labSiteId" label="Site"></micro-valid-label>
                      </b><br>
                      <micro-site-select #siteSite
                                         [(ngModel)]="ticket.siteId"
                                         [neId]="ticket.neId ? ticket.neId : '--ANY--'"
                                         [pickList]="false"
                                         placeholder="Site"
                                         (siteChange)="onSiteChanged($event)"
                                         [disabled]="false"
                                         [required]="ticket.affectedResourceType === 'SITE'"
                                         [autoSearchableLength]="1"
                                         id="siteSite" name="siteSite">
                      </micro-site-select>
                      <div style="display: none">
                        <input #labSiteId="ngModel"
                               [(ngModel)]="ticket.siteId"
                               [required]="ticket.affectedResourceType === 'SITE'"
                               id="labSiteId" name="labSiteId">
                      </div>
                    </td>
                  </tr>
                </table>
              </td>

              <td style="vertical-align: top;">
                <table class="simpleTable">
                  <tr>
                    <td>
                      <b>
                        <micro-valid-label for="eventCategoryId" [model]="eventCategoryId"
                                           label="Event Category"></micro-valid-label>
                      </b>
                      <micro-event-classification-select #eventCategoryId="ngModel"
                                                         [classificationType]="'EVENT_CATEGORY'"
                                                         [(ngModel)]="ticket.eventCategoryId"
                                                         [parentId]="undefined"
                                                         [placeholder]="'Select Event Category'"
                                                         [required]="true"
                                                         id="eventCategoryId"
                                                         name="eventCategoryId">
                      </micro-event-classification-select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>
                        <micro-valid-label for="eventTypeId" [model]="eventTypeId"
                                           label="Event"></micro-valid-label>
                      </b>
                      <b></b><br>
                      <micro-event-classification-select #eventTypeId="ngModel"
                                                         [classificationType]="'EVENT_TYPE'"
                                                         [(ngModel)]="ticket.eventTypeId"
                                                         [parentId]="ticket.eventCategoryId"
                                                         [placeholder]="'Select Event Type'"
                                                         [required]="true"
                                                         id="eventTypeId"
                                                         name="eventTypeId">
                      </micro-event-classification-select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>
                        <micro-valid-label for="faultReasonId" [model]="faultReasonId"
                                           label="Fault Reason/1"></micro-valid-label>
                      </b><br>
                      <micro-event-classification-select #faultReasonId="ngModel"
                                                         [classificationType]="'FAULT_REASON'"
                                                         [(ngModel)]="ticket.faultReasonId"
                                                         [parentId]="ticket.eventTypeId"
                                                         [placeholder]="'Select Fault Reason'"
                                                         [required]="false"
                                                         id="faultReasonId"
                                                         name="faultReasonId"
                      >
                      </micro-event-classification-select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>
                        <micro-valid-label for="clearReasonId" [model]="clearReasonId"
                                           label="Clear Reason/2"></micro-valid-label>
                      </b><br>
                      <micro-event-classification-select #clearReasonId="ngModel"
                                                         [classificationType]="'CLEAR_REASON'"
                                                         [(ngModel)]="ticket.clearReasonId"
                                                         [parentId]="ticket.faultReasonId"
                                                         [placeholder]="'Select Clear Reason'"
                                                         [required]="false"
                                                         id="clearReasonId"
                                                         name="clearReasonId">
                      </micro-event-classification-select>
                    </td>
                  </tr>
                </table>
              </td>

              <td style="vertical-align: top;">
                <table class="simpleTable">
                  <tr>
                    <td>
                      <b>Service Provider</b>
                      <micro-contactCompany-select [(ngModel)]="ticket.serviceProviderId"
                                                   (contactCompanyChange)="onServiceProviderChange($event)"
                                                   [placeholder]="'Select Service Provider'"
                                                   id="serviceProviderId"
                                                   name="serviceProviderId">
                      </micro-contactCompany-select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Department/Region</b><br>
                      <micro-contactDepartment-select [(ngModel)]="ticket.departmentId"
                                                      [contactCompanyId]="ticket.serviceProviderId"
                                                      (contactDepartmentChange)="onDepartmentChange($event)"
                                                      [placeholder]="'Select Department/Region'"
                                                      id="departmentId"
                                                      name="departmentId">
                      </micro-contactDepartment-select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Assigned to Engineer</b><br>
                      <micro-contact-select [(ngModel)]="ticket.assignedToUserId"
                                            [contactDepartmentId]="ticket.departmentId"
                                            (contactChange)="onAssignedToChange($event)"
                                            [pickList]="false"
                                            [placeholder]="'Select Resource'"
                                            id="assignedToUserId"
                                            name="assignedToUserId">
                      </micro-contact-select>
                    </td>
                  </tr>
                  <tr *ngIf="ticket.affectedResourceType === 'SITE'">
                    <td style="padding: 10px; background: white;" class="text-right">
                      <button mat-raised-button class="primary" type="button" [disabled]="!ticket.siteId"
                              (click)="syncSiteContact()" style="width: 40%;">
                        <mat-icon>person_pin_circle</mat-icon>
                        Use Site Contact
                      </button>
                    </td>
                  </tr>

                </table>
              </td>
            </tr>
            <tr>
              <td colspan="99">
                <b>Work Log Feedback</b><br/>
                <textarea style="min-width: 350px; min-height: 220px;"
                          [(ngModel)]="ticket.worklogFeedback"
                          rows="8"
                          name="worklogFeedback">
                </textarea>
              </td>
            </tr>

            </tbody>
          </table>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Worklog">
      <micro-ticket-worklog #worklog [ticketId]="ticket.id" [refreshWorklog]="refreshWorklog"></micro-ticket-worklog>
    </mat-tab>
  </mat-tab-group>

</div>
